export const SET_MUSIC = 'SET_MUSIC'
export const SET_THEME = 'SET_THEME'
export const SET_VOLUME = 'SET_VOLUME'
export const SET_SPEED = 'SET_SPEED'
export const SET_COLLAPSED = 'SET_COLLAPSED'
export const SET_PLAY_MODE = 'SET_PLAY_MODE'
export const SYNC_MEDIA = 'SYNC_MEDIA'
export const SAVE_STATE = 'SAVE_STATE'
export const RECORD_VOLUME = 'RECORD_VOLUME'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/store/types.ts